<template>
	<div>
		<h2>{{ $lib.translate('Вы выбрали') }}</h2>
		<br>
		<p v-if="step1.name">{{ $lib.translate('Судья') }}: <b>{{ step1.name.translate.ru.name }}</b></p>
		<p v-if="step1.name2 && step2.current">{{ step2.current.type === 'person' ? $lib.translate('Физ. лицо') : $lib.translate('Компания') }}: <b>{{ step2.current.translate.ru.name }}</b></p>
		<br>
		<h2>{{ $lib.translate('Документы') }}</h2>
		<v-data-table
			:headers="step2.headers"
			:items="step2.data"
			:hide-default-footer="true"
			:items-per-page="step2.meta ? step2.meta.per_page : 9999"
			v-if="step2.data && step2.data.length"
		></v-data-table>
		<template v-else>
			<v-alert :value="true" color="info" type="info">{{ $lib.translate('Ничего не найдено') }}</v-alert>
		</template>
		<div class="d-flex justify-center pt-3" v-if="step2.meta && step2.meta.last_page > 1">
			<v-pagination
				v-model="page"
				:total-visible="7"
				:length="46"
			></v-pagination>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'SearchStep2',

		data () {
			return {
				page: 1,
				tab: 0
			}
		},

		computed: {
			step2 () {
				return this.$store.getters.PAGE('step2');
			},
			step1 () {
				return this.$store.getters.PAGE('step1');
			}
		},

		watch: {
			page: function () {
				if (this.step2.onChange) {
					this.step2.onChange(this.page);
				}
			},
		}
	}
</script>
